// extracted by mini-css-extract-plugin
module.exports = {"date":"capacityGasSliding_date__3qe5R"};